export interface Cause {
  actions: {
    action: string
    actionID: string
  }[]
  cause: string
  causeID: string
}

export interface CauseState {
  loading: boolean
  recommendedCauses: null | Cause[]
}

export const initialState = {
  loading: false,
  recommendedCauses: null,
}

export const causes = (
  state: CauseState = initialState,
  action: ReduxAction,
): CauseState => {
  switch (action.type) {
    case 'START_LOADING_ANOMALY_BREAKDOWN_CAUSES': {
      return {
        ...state,
        loading: true,
        recommendedCauses: [],
      }
    }
    case 'GET_ANOMALY_BREAKDOWN_CAUSES': {
      return {
        ...state,
        loading: false,
        recommendedCauses: [...action.payload.recommendedCauses],
      }
    }
    default:
      return state
  }
}
